import { render, staticRenderFns } from "./RequiredDocsMainView.vue?vue&type=template&id=5f14589e"
import script from "./RequiredDocsMainView.vue?vue&type=script&lang=js"
export * from "./RequiredDocsMainView.vue?vue&type=script&lang=js"
import style0 from "./RequiredDocsMainView.vue?vue&type=style&index=0&id=5f14589e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports